export const GET_ALL_VENDOR_EVENTS_PAGINATED_SUCCESS = 'GET_ALL_VENDOR_EVENTS_PAGINATED_SUCCESS';
export const GET_ALL_VENDOR_EVENTS_PAGINATED_ERROR = 'GET_ALL_VENDOR_EVENTS_PAGINATED_ERROR';
export const SET_PAGINATION_DATA = 'SET_PAGINATION_DATA';
export const SET_LOADING = 'SET_LOADING';
